// this is an autogenerated file from App/Account/Content/Marketing/LocationChooser/data.graphql
import { gql } from 'Data/Api'

export default gql`
query app__App_Account_Content_Marketing_LocationChooser{
  session_user_locations(order_by: { name: asc }) {
    _id
    text: name
  }
}

`